import {
    TooltipContainer,
    Title,
    TableRowStyle,
    TableCellStyle,
    TableCellDomainMarker,
    TableCellDomainName,
} from "app/pages/website-analysis/traffic-sources/mmx/components/ChannelsOverviewBarChart/ChannelsOverviewBarChartTooltip";
import { percentageSignFilter } from "app/filters/ngFilters";
export const Tooltip = (props) => {
    const { socialMediaDataPoints, socialMedia } = props;

    const TableRow = ({ point }) => {
        const { color, series } = point;
        const { name } = series;
        const share = point.point.share;
        const value = percentageSignFilter()(share, 2);
        return (
            <TableRowStyle>
                <TableCellStyle>
                    <TableCellDomainMarker background={color} />
                    <TableCellDomainName>{name}</TableCellDomainName>
                </TableCellStyle>
                <TableCellStyle>{value}</TableCellStyle>
            </TableRowStyle>
        );
    };

    return (
        <TooltipContainer>
            <Title>{socialMedia}</Title>
            {socialMediaDataPoints.map((pointData, index) => (
                <TableRow
                    point={pointData}
                    key={index}
                />
            ))}
        </TooltipContainer>
    );
};
